import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const ChevronCircleDown = ({
	size,
	...props
}: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M16 30C8.28 30 2 23.72 2 16C2 8.28 8.28 2 16 2C23.72 2 30 8.28 30 16C30 23.72 23.72 30 16 30ZM16 4C9.383 4 4 9.383 4 16C4 22.617 9.383 28 16 28C22.617 28 28 22.617 28 16C28 9.383 22.617 4 16 4Z" />
		<path d="M16 17.719L11.624 14.219C11.453 14.082 11.236 13.999 11 13.999C10.448 13.999 10 14.447 10 14.999C10 15.315 10.147 15.596 10.376 15.779L15.377 19.78C15.548 19.917 15.765 19.999 16.001 19.999C16.237 19.999 16.454 19.917 16.625 19.78L21.626 15.78C21.855 15.597 22.002 15.316 22.002 15C22.002 14.448 21.554 14 21.002 14C20.766 14 20.549 14.082 20.378 14.22L16.002 17.72L16 17.719Z" />
	</svg>
);

export default ChevronCircleDown;
